import {getAudioList} from '../CHELAudio';

import {getMainAudioContext, setMainAudioContext} from './dataOps';

// 全ての音楽のサスペンド・レジューム
export const hel_audio_SuspendAll = () => {
  const audioList = getAudioList();
  for (let index = 0; index < audioList.length; index++) {
    if (audioList[index] === null) continue;

    audioList[index]?.suspend();
  }
};

export const hel_audio_ResumeAll = () => {
  const audioList = getAudioList();
  for (let index = 0; index < audioList.length; index++) {
    if (audioList[index] === null) continue;

    audioList[index]?.resume();
  }
};

/**
 * 1タブ1AudioContexを初期化
 */
export const initMainAudioContext = () => {
  const audioContext = new (window.AudioContext ?? window.webkitAudioContext)();
  setMainAudioContext(audioContext);
  return getMainAudioContext();
};
